"use client";

import { ReactNode } from "react";
import Image from "next/image";
import butterfly from "public/images/black-butterfly.svg";
import AlertBanner from "common/components/AlertBanner";

interface ErrorComponentProps {
	title: string;
	message?: string;
	buttons?: ReactNode; // allows passing in custom buttons
	error?: Error | null;
}

export default function ErrorComponent({
	title,
	message,
	buttons,
	error,
}: ErrorComponentProps) {
	if (error) {
		console.error("ErrorComponent rendered with error:", error);
	}
	return (
		<div className="full-page-center">
			<div className="max-width-center flex-col">
				<div className="flex-row centered">
					<Image
						src={butterfly}
						alt="Butterfly Icon"
						width={80}
						height={80}
						priority
					/>
				</div>

				{/* Title */}
				<h2 className="mt-3">{title}</h2>

				{/* Message */}
				<div className="flex-row centered">
					<p className="mt-3">{message}</p>
				</div>
				{/* Button row */}
				<div className="flex-row centered mt-6 mb-6">
					{buttons ? buttons : null}
				</div>
				{error && (
					<AlertBanner
						severity="error"
						title={error?.message || "An unexpected error occurred"}
					/>
				)}
			</div>
		</div>
	);
}
